import { render, staticRenderFns } from "./PolizasIECard.vue?vue&type=template&id=488a679e&scoped=true&"
import script from "./PolizasIECard.vue?vue&type=script&lang=js&"
export * from "./PolizasIECard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasIECard.vue?vue&type=style&index=0&id=488a679e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a679e",
  null
  
)

export default component.exports